export const CarpetasAdjuntos = {
    CarpetaNoticiaPanelPublico: 'NewsDashboard',
    ImagenLogin: 'LoginImage',
    FondoInicioSesion: 'LoginBackground',
    LogoCompania: 'CompanyLogo',
    FondoHome: 'HomeBackground',
}

